/**
 * Application configuration.
 *
 * At runtime, a config.js script is loaded for custom application
 * configuration. The values below are the defaults and config.js is empty
 * unless overwritten. When the script is overwritten, it should assign values
 * to `window` properties as needed.
 */

// Token used by the geocoder. Set to null to disable the geocoder.
export const MAPBOX_ACCESS_TOKEN =
  process.env.MAPBOX_ACCESS_TOKEN ||
  'pk.eyJ1IjoicGxhbmV0IiwiYSI6ImNrOTBhYWk3cDBoemszbG11bHQ1enVodjMifQ.yv8qxqOEs2m2ndD4F-c-lA';

// Optional URL for auth endpoint. If not provided,
// https://api.planet.com/v0/auth/login will be used.
export const AUTH_HOSTNAME =
  'AUTH_HOSTNAME' in window ? window.AUTH_HOSTNAME : '';

// Optional URL for API endpoint. The mosaic listing is assumed to be at
// ${API_HOSTNAME}/mosaic/experimental/mosaics
export const API_HOSTNAME =
  'API_HOSTNAME' in window ? window.API_HOSTNAME : 'https://api.planet.com';

// The base path for the mosaic listing in the API, as mentioned above
export const API_MOSAICS_BASE_PATH = `${API_HOSTNAME}/basemaps/v1/mosaics`;

// URL template for a tile set to show under mosaics
export const BASE_LAYER_STYLE =
  'BASE_LAYER_STYLE' in window
    ? window.BASE_LAYER_STYLE
    : 'mapbox://styles/planet/ckhb7uh3i0bex19pi8epjbwdm';

// URL template for a tile set to show over mosaics. Set to null for none.
export const LABELS_STYLE =
  'LABELS_STYLE' in window
    ? window.LABELS_STYLE
    : 'mapbox://styles/planet/ck9qfizat2wz81ip84e3ac018';
